import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../components/AtiraIcon";
import { Flex } from "../../../components/Flex";
import { FontSize, Text } from "../../../components/Text";
import { Spacing } from "../../../theme/Spacing";
import { AtiraImage } from "../../../components/Image";
import { Images } from "../../../assets";

const Container = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
  gap: ${Spacing.xl};
  width: 100%;
  align-self: flex-start;
`;

const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.s};
  font-size: ${FontSize.m};
  padding-inline-start: ${Spacing.m};

  li::marker {
    color: ${({ theme }) => theme.main};
  }
`;

export const DripCampaignCreateEditStepGetStarted: React.FC = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "campaigns.dripCampaign.step.getStarted",
  });

  return (
    <Container>
      <Flex flexDirection="column" gap="m" width="50%">
        <Flex alignItems="center" gap="s">
          <AtiraIcon icon={faQuestionCircle} color="main" size="xl" />

          <Text fontSize="l" fontWeight={"bold"} color="main">
            {t("title")}
          </Text>
        </Flex>

        <Text color="darkerSub">{t("description.1")}</Text>

        <Text fontWeight={"bold"}>{t("description.2")}</Text>

        <StyledList>
          {Array.from({ length: 4 }, (_, index) => (
            <li key={index}>{t(`description.list.${index + 1}`)}</li>
          ))}
        </StyledList>
      </Flex>
      <Flex width="50%">
        <AtiraImage src={Images.CampaignsInfoGraphic} />
      </Flex>
    </Container>
  );
};
